const cancelInvoiceInstallment = {
  'cancelInvoiceInstallment.title': 'Cancel Invoice Installment',
  'cancelInvoiceInstallment.emptyState':
    "There's no invoice installment to cancel.",
  'cancelInvoiceInstallment.errorState':
    "Something went wrong and we couldn't fetch invoice installment data.",
  'cancelInvoiceInstallment.confirm': 'Confirm',
  'cancelInvoiceInstallment.outcomeSuccess': 'Invoice Installment canceled',
  'cancelInvoiceInstallment.close': 'Close',

  'cancelInvoiceInstallment.firstPaymentDate': 'First payment date',
  'cancelInvoiceInstallment.firstPaymentAmount': 'First payment amount',
  'cancelInvoiceInstallment.numberInstallments': 'Number of installments',
  'cancelInvoiceInstallment.contractAmount': 'Contract amount',
  'cancelInvoiceInstallment.principalAmount': 'Principal amount',
  'cancelInvoiceInstallment.installmentAmount': 'Installment amount',
  'cancelInvoiceInstallment.interestRate': 'Interest rate',
};

export default cancelInvoiceInstallment;
